import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import type { PaginationMeta } from '@recruitee/http-types';
import { tableDataDefaultParams } from '@recruitee/referrals-types';
import type {
  ReferralApplication,
  ClaimStatus,
  ApplicationsParams,
} from '@recruitee/referrals-types';

@Injectable({ providedIn: 'root' })
export class ApplicationsHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadApplications(
    params: Partial<ApplicationsParams>,
  ): Observable<{ rows: ReferralApplication[]; meta: PaginationMeta }> {
    return this.httpApi
      .get(`/referral/applications`, { ...tableDataDefaultParams, ...params })
      .pipe(
        map((data: { meta: PaginationMeta; applications: ReferralApplication[] }) => ({
          meta: data.meta,
          rows: data.applications,
        })),
      );
  }

  public settleApplication(
    applicationId: number,
    claimStatus: ClaimStatus,
  ): Observable<ReferralApplication> {
    return this.httpApi.patch(`/referral/applications/${applicationId}/settle`, null, {
      application: {
        claimStatus,
      },
    });
  }

  public bulkSettleApplication(
    applicationIds: number[],
    claimStatus: ClaimStatus,
  ): Observable<{ uuid: string }> {
    return this.httpApi.patch(`/referral/applications/settle`, null, {
      applicationIds,
      application: {
        claimStatus,
      },
    });
  }
}
